import { useEffect, useState } from "react";

import { addressToPosition } from "utils/map";

const useBounds = (addresses) => {
  const [bounds, setBounds] = useState(null);

  useEffect(() => {
    if (!addresses.length) return;

    const newBounds = new window.google.maps.LatLngBounds();
    addresses.forEach((address) => newBounds.extend(addressToPosition(address)));
    setBounds(newBounds);
  }, [addresses]);

  return bounds;
};

export default useBounds;
